import { CustomLink, CustomSelect, VersionButton } from './styles';
import { View } from './types';

export const removeSpaces = (str: string | number): string => {
  return String(str).toLowerCase().replace(/\s/g, '');
};
export const removeVersionWithDot = (str: string): string => {
  return str.replace(/v\.(\d+)/i, '$1');
};
export const componentMap: Record<View, React.ElementType> = {
  version: VersionButton,
  link: CustomLink,
  default: CustomSelect,
};
